import { ReducerActionRotaSP } from 'store/modules/types';

import { ConsultarNaturalidadesRequest, Types } from './types';

export function consultarNaturalidadesRequest(
	token: string,
	payload: ConsultarNaturalidadesRequest,
	instanceRequest?: string,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_NATURALIDADES_REQUEST,
		token,
		payload: {
			limite: payload.limite,
			current: payload.registroInicial,
			id: Number(payload.id) || null,
			digito: Number(payload.digito) || null,
			descricao: payload.descricao,
			sigla: payload.sigla,
			uf: payload.uf,
		},
		instanceRequest,
	};
}
export function consultarNaturalidadesSuccess(
	payload: object,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_NATURALIDADES_SUCCESS,
		payload,
	};
}
export function consultarNaturalidadesFailure(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_NATURALIDADES_FAILURE,
		payload: null,
	};
}
export function consultarNaturalidadesClear(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_NATURALIDADES_CLEAR,
		payload: null,
	};
}
